// HomePage Styles Module
export const homePageStyles = {
  // Main container styles
  mainContainer: {
    minHeight: '100vh',
    padding: '0 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    top: '-60px'
  },

  // Chrome extension promo styles
  chromePromoContainer: {
    position: 'fixed',
    top: 80,
    right: 32,
    zIndex: 2000,
    background: 'var(--color-bg-card)',
    color: 'var(--color-text)',
    borderRadius: 16,
    padding: '18px 20px 20px 20px',
    minWidth: 260,
    maxWidth: 320,
    boxShadow: '0 2px 12px var(--color-shadow)',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: '1px solid var(--color-border)'
  },

  chromePromoCloseButton: {
    position: 'absolute',
    top: 8,
    right: 10,
    background: 'rgba(0,0,0,0.5)',
    border: 'none',
    color: '#fff',
    fontSize: 28,
    cursor: 'pointer',
    opacity: 1,
    zIndex: 4000,
    textShadow: '0 1px 4px #000',
    borderRadius: '50%',
    width: 36,
    height: 36,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
  },

  chromePromoText: {
    fontSize: 15,
    marginBottom: 12,
    fontWeight: 500
  },

  chromePromoLink: {
    display: 'inline-block',
    background: 'var(--color-primary)',
    color: 'var(--color-bg-card)',
    fontWeight: 700,
    fontSize: 15,
    borderRadius: 8,
    padding: '10px 0',
    width: '100%',
    textDecoration: 'none',
    marginTop: 4,
    boxShadow: '0 1px 4px var(--color-shadow)',
    transition: 'background 0.2s, color 0.2s'
  },

  // Header buttons styles
  headerButtons: {
    position: 'fixed',
    top: 24,
    right: 32,
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    zIndex: 3000
  },

  loadingSpinner: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    background: 'var(--color-bg)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px solid var(--color-border)'
  },

  loadingSpinnerInner: {
    width: 16,
    height: 16,
    border: '2px solid var(--color-primary)',
    borderTop: '2px solid transparent',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  },

  profileButton: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    background: 'var(--color-primary)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontSize: 16,
    fontWeight: 'bold',
    cursor: 'pointer',
    userSelect: 'none',
  },

  loginButton: {
    fontSize: '15px',
    padding: '10px 22px',
    background: 'var(--color-primary)',
    color: 'var(--color-bg-card)',
    fontWeight: 700,
    border: 'none',
    borderRadius: '8px',
    boxShadow: '0 2px 8px var(--color-shadow)',
    opacity: 1,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'background 0.2s, color 0.2s',
    cursor: 'pointer',
    minWidth: '100px',
    height: '40px'
  },

  // Main content styles
  mainContent: {
    textAlign: 'center',
    maxWidth: '800px',
    width: '100%'
  },

  logoContainer: {
    marginBottom: '40px'
  },

  logoImage: {
    width: 80,
    height: 80
  },

  logoSection: {
    marginBottom: '16px',
    cursor: 'pointer'
  },

  title: {
    color: 'var(--color-text)',
    fontSize: '40px',
    fontWeight: 'bold',
    marginBottom: '16px',
    textShadow: '0 4px 8px var(--color-shadow)'
  },

  subtitle: {
    color: 'var(--color-text)',
    fontSize: '16px',
    opacity: 0.6,
    marginBottom: '6px',
    fontWeight: 500
  },

  description: {
    color: 'var(--color-text)',
    fontSize: '14px',
    opacity: 0.5
  },

  // Search form styles
  searchForm: {
    marginBottom: '0px'
  },

  searchFormContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px'
  },

  searchInputContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: '600px',
    position: 'relative'
  },

  searchInput: {
    paddingRight: '60px',
    height: '100px',
    fontSize: '24px',
    borderRadius: '22px',
    boxShadow: '0 0 0 3px var(--color-primary)',
    border: '2px solid var(--color-primary)',
    fontWeight: 500
  },

  searchButton: {
    position: 'absolute',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'var(--color-primary)',
    border: 'none',
    borderRadius: '50%',
    width: '44px',
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 2px 8px var(--color-shadow)',
    transition: 'all 0.3s ease'
  },

  // Suggestion bar styles
  suggestionBar: {
    width: '100%',
    maxWidth: '600px',
    margin: '12px auto 0 auto',
    padding: '16px',
    background: 'var(--color-bg-card)',
    borderRadius: '12px',
    border: '2px solid var(--color-border)',
    boxShadow: '0 4px 12px var(--color-shadow)',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    justifyContent: 'center'
  },

  suggestionBarTitle: {
    width: '100%',
    margin: '0 0 12px 0',
    color: 'var(--color-text)',
    fontSize: '16px',
    fontWeight: '600',
    textAlign: 'center'
  },

  suggestionButton: {
    padding: '8px 16px',
    fontSize: '14px',
    background: 'var(--color-bg)',
    color: 'var(--color-text)',
    border: '1px solid var(--color-border)',
    borderRadius: '20px',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'all 0.2s ease',
    textTransform: 'capitalize'
  },

  // Suggestions list styles
  suggestionsList: {
    width: '100%',
    maxWidth: '600px',
    margin: '8px auto 0 auto',
    background: 'var(--color-bg-card)',
    borderRadius: '12px',
    border: '2px solid var(--color-border)',
    boxShadow: '0 4px 12px var(--color-shadow)',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },

  suggestionsListTitle: {
    margin: '0 0 12px 0',
    color: 'var(--color-text)',
    fontSize: '16px',
    fontWeight: '600',
    textAlign: 'center'
  },

  suggestionsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '10px'
  },

  topicButton: {
    padding: '10px 16px',
    fontSize: '14px',
    background: 'var(--color-bg)',
    color: 'var(--color-text)',
    border: '1px solid var(--color-border)',
    borderRadius: '8px',
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'all 0.2s ease',
    fontWeight: '400',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    lineHeight: '1.4'
  },

  // Footer styles
  footer: {
    color: 'var(--color-text)',
    opacity: 0.7,
    fontSize: '14px',
    marginTop: '40px'
  },

  // Responsive styles
  responsiveStyles: `
    @keyframes spin {
      to { transform: rotate(360deg); }
    }

    @media (max-width: 900px) {
      .mainContent {
        flex-direction: column !important;
        padding: 16px !important;
        gap: 16px !important;
      }
    }
    @media (max-width: 768px) {
      .header-buttons {
        display: none !important;
      }
    }

    @media (max-width: 480px) {
      .search-input {
        height: 70px;
        font-size: 18px;
        width: 100vw !important;
        max-width: 100vw !important;
        min-width: 0 !important;
        box-sizing: border-box !important;
        padding-right: 56px !important;
      }
      .search-input::placeholder {
        font-size: 14px !important;
      }
      .searchButton {
        width: 36px !important;
        height: 36px !important;
        right: 6px !important;
      }
      .searchInputContainer {
        width: 100vw !important;
        max-width: 100vw !important;
        min-width: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
      }
      .searchFormContainer {
        width: 100vw !important;
        max-width: 100vw !important;
        min-width: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
      }
      .mainContent, .main-container, form, .home-page {
        width: 100vw !important;
        max-width: 100vw !important;
        min-width: 0 !important;
        margin: 0 !important;
        /* Do not use padding: 0 — it strips safe-area / explore bottom spacing and header offset */
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
      .home-page.explore-landing {
        min-height: auto !important;
      }
      .explore-inner.mainContent {
        /* .main-content already adds top inset for the nav; small gap only */
        padding-top: 12px !important;
        padding-left: 14px !important;
        padding-right: 14px !important;
      }
      .home-page, .main-container {
        overflow-x: hidden !important;
      }
      .title {
        font-size: 28px;
      }
      .logo-image {
        width: 60px;
        height: 60px;
      }
    }
  `,
};

// Helper function to get responsive styles
export const getHomePageResponsiveStyles = () => homePageStyles.responsiveStyles; 